import { getSystemIdentity, EEnvironment } from 'utils/system-identity';

export class GoogleAuthService {
  static getGoogleAuthUrl = (): string => {
    const { hostname } = window.location;

    const { authHost, redirect } = getSystemIdentity(hostname as EEnvironment);

    return `${authHost[hostname as EEnvironment]}/google-login?redirectURL=${
      redirect[hostname as EEnvironment]
    }`;
  };
}
